import { IFormChange, IFormChanges } from "form/model"

export function getFormChangesCount(formChanges: IFormChanges): number {
  let total = 0
  const allChanges = [
    ...formChanges.configuration,
    ...formChanges.geoTargets,
    ...formChanges.screens,
    ...formChanges.audience,
    ...formChanges.creative
  ]
  for (const change of allChanges) {
    total += change.changeCount
  }
  return total
}

export function getFinalizedArrayChange(
  labelKey: string,
  oldValues: Array<string | number> | undefined,
  newValues: Array<string | number> | undefined,
  getLabel: (id: string | number) => string
): IFormChange {
  const change: IFormChange = getEmptyFormChange(labelKey)
  if (!oldValues && !newValues) {
    return change
  }
  if (!oldValues) {
    if (!newValues) {
      return change
    }
    change.addedItems.push(...newValues.map(i => getLabel(i)))
    return change
  } else if (!newValues) {
    change.deletedItems.push(...oldValues.map(i => getLabel(i)))
    return change
  }
  for (const oldValue of oldValues) {
    if (newValues.indexOf(oldValue) !== -1) {
      continue
    }
    change.deletedItems.push(getLabel(oldValue))
  }
  for (const newValue of newValues) {
    if (oldValues.indexOf(newValue) !== -1) {
      continue
    }
    change.addedItems.push(getLabel(newValue))
  }
  return finalizeChange(change)
}

export const getEmptyFormChange = (labelKey: string): IFormChange => ({
  labelKey,
  hasChange: false,
  changeCount: 0,
  addedItems: [],
  deletedItems: [],
  updatedItems: []
})

export const finalizeChange = (change: IFormChange): IFormChange => {
  change.changeCount = change.addedItems.length + change.deletedItems.length + change.updatedItems.length
  change.hasChange = change.changeCount > 0
  return change
}
